export interface PostalCode {
  id: string
  nmCirc: string
  nmNumcp: string
  nmRegnAdmns: string
  mnMrc: string
  codeDesgn: string
  code: string
  coRegnAdmns: string
  coMun: number
  coMrc: number
  coCirc: number
}

/** Raw row from Django (snake) or after axios camelize interceptor. */
export type PostalCodeDto = {
  id: string
  code: string
  nm_circ?: string
  nmCirc?: string
  nm_numcp?: string
  nmNumcp?: string
  nm_regn_admns?: string
  nmRegnAdmns?: string
  mn_mrc?: string
  mnMrc?: string
  code_desgn?: string
  codeDesgn?: string
  co_regn_admns?: string | number
  coRegnAdmns?: string | number
  co_mun?: number
  coMun?: number
  co_mrc?: number
  coMrc?: number
  co_circ?: number
  coCirc?: number
}

export type PostalCodePageDto = {
  count?: number
  next?: string | null
  previous?: string | null
  results: PostalCodeDto[]
}

export type SearchCircumscriptionsResponse = PostalCode[]

export interface PostalCodeEntry {
  code: string
  nmCirc: string
}

export class PostalCodeDtoFactory {
  static fromDto(dto: PostalCodeDto): PostalCode {
    return {
      id: dto.id,
      code: dto.code,
      // Axios responseInterceptor camelizes Django snake_case → nmCirc
      nmCirc: dto.nmCirc ?? dto.nm_circ ?? '',
      nmNumcp: dto.nmNumcp ?? dto.nm_numcp ?? '',
      nmRegnAdmns: dto.nmRegnAdmns ?? dto.nm_regn_admns ?? '',
      mnMrc: dto.mnMrc ?? dto.mn_mrc ?? '',
      codeDesgn: dto.codeDesgn ?? dto.code_desgn ?? '',
      coRegnAdmns: String(dto.coRegnAdmns ?? dto.co_regn_admns ?? ''),
      coMun: dto.coMun ?? dto.co_mun ?? 0,
      coMrc: dto.coMrc ?? dto.co_mrc ?? 0,
      coCirc: dto.coCirc ?? dto.co_circ ?? 0,
    }
  }

  /** Accept a bare array or a DRF paginated `{ results }` payload. */
  static fromApiPayload(payload: PostalCodeDto[] | PostalCodePageDto | unknown): PostalCode[] {
    const rows = Array.isArray(payload)
      ? payload
      : payload && typeof payload === 'object' && Array.isArray((payload as PostalCodePageDto).results)
        ? (payload as PostalCodePageDto).results
        : []
    return rows
      .map((row) => PostalCodeDtoFactory.fromDto(row))
      .filter((row) => !!row.nmCirc && !!row.code)
  }
}
